import { SETUP_GOALS, SetupGoal } from "connected-components/optimize-experiments/constants"
import { percentageNoSymbolFormatter } from "helpers/formatters/numbers"
import { IsoDate } from "helpers/types/dates"
import {
  OptimizationConfiguration,
  OptimizationConstraints,
  OptimizationObjective,
} from "connected-components/optimize-experiments/hooks/types"
import { SetupSection, RulesSection } from "connected-components/optimize-experiments/configuration-sections"

interface GraphQLOptimizationConfiguration {
  objective: Partial<OptimizationObjective>
  constraints: Partial<OptimizationConstraints>
}

const GOAL_OBJECTIVE_MAP: Record<SetupGoal, OptimizationObjective> = {
  [SETUP_GOALS.MINIMIZE_TOTAL_RISK]: { minimizeFactorRisk: true },
}

interface FormSections {
  setup: SetupSection
  rules: RulesSection
}

export function transformFormToConfiguration(
  endDate: IsoDate,
  setup: Partial<SetupSection> = {},
  rules: Partial<RulesSection> = {},
): OptimizationConfiguration {
  const objectives: OptimizationObjective[] = []

  if (setup?.goal && GOAL_OBJECTIVE_MAP[setup.goal]) {
    objectives.push(GOAL_OBJECTIVE_MAP[setup.goal])
  }

  const constraints: Partial<OptimizationConstraints> = {}
  if (rules?.maxTurnover !== undefined && rules.maxTurnover !== null) {
    const maxTurnoverValue = parseFloat(String(rules.maxTurnover))
    constraints.maxTurnover = isNaN(maxTurnoverValue) ? 1.0 : maxTurnoverValue / 100.0
  }

  return {
    on: endDate,
    objectives,
    constraints,
  }
}

export function transformConfigurationToForm(
  configuration: Partial<GraphQLOptimizationConfiguration>,
): FormSections {
  let goal: SetupGoal = SETUP_GOALS.MINIMIZE_TOTAL_RISK

  // `objective` comes from GraphQL, as it's one of the fields on ModelOptimization, even though it's a list
  if (configuration.objective) {
    switch (true) {
      case configuration.objective.minimizeFactorRisk:
        goal = SETUP_GOALS.MINIMIZE_TOTAL_RISK
        break
      default:
        break
    }
  }

  const setup: SetupSection = {
    goal,
  }

  const rules: RulesSection = {
    maxTurnover: configuration.constraints?.maxTurnover !== undefined
      ? percentageNoSymbolFormatter(configuration.constraints.maxTurnover)
      : "100.00",
  }

  return {
    setup,
    rules,
  }
}
